/* IBEY header search hint rotation. Search remains standard GET form. */
(()=> {
  const hints=["Search overhead showers","Search hand shower sets","Search health faucets","Search kitchen sinks","Search bathroom accessories"];
  const start=()=>{
    const field=document.querySelector("#ibey-header-search-input");
    if(!field||window.matchMedia?.("(prefers-reduced-motion: reduce)").matches)return;
    let idx=0;
    const update=()=>{
      if(document.visibilityState!=="visible"||document.activeElement===field||field.value)return;
      idx=(idx+1)%hints.length;
      field.placeholder=hints[idx];
    };
    window.setInterval(update,3600);
  };
  if(document.readyState==="loading")document.addEventListener("DOMContentLoaded",start,{once:true});else start();
})();